import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from './SvgIcon';

const EnvoyLogo = ({ fillColor, ...props }) => (
    <SvgIcon viewBox="0 0 128 128" {...props}>
        <g fill={fillColor}>
            <path d="M55.245 48.179h17.51c1.434 0 2.611 -1.178 2.611 -2.611s-1.178 -2.611 -2.611 -2.611h-17.51c-1.434 0 -2.611 1.178 -2.611 2.611s1.178 2.611 2.611 2.611z" />
            <path d="M88.397 27.136H39.603c-3.482 0 -6.323 2.816 -6.323 6.323v61.107c0 3.482 2.816 6.323 6.323 6.323h48.794c3.482 0 6.323 -2.816 6.323 -6.323V33.459c0 -3.507 -2.842 -6.323 -6.323 -6.323zm1.075 65.869c0 1.434 -1.178 2.611 -2.611 2.611H41.139c-1.434 0 -2.611 -1.178 -2.611 -2.611V34.97c0 -1.434 1.178 -2.611 2.611 -2.611h45.722c1.434 0 2.611 1.178 2.611 2.611v58.035z" />
            <path d="M73.395 79.821H57.856v-7.066h9.088c1.434 0 2.611 -1.178 2.611 -2.611s-1.178 -2.611 -2.611 -2.611H57.856v-7.066h14.899c1.434 0 2.611 -1.178 2.611 -2.611s-1.178 -2.611 -2.611 -2.611h-17.51c-1.434 0 -2.611 1.178 -2.611 2.611v24.576c0 1.434 1.178 2.611 2.611 2.611h18.15c1.434 0 2.611 -1.178 2.611 -2.611s-1.152 -2.611 -2.611 -2.611z" />
        </g>
    </SvgIcon>
);

EnvoyLogo.propTypes = {
    fillColor: PropTypes.string
};

EnvoyLogo.defaultProps = {
    fillColor: '#eb5444'
};

EnvoyLogo.displayName = 'EnvoyLogoIcon';

export default EnvoyLogo;
